import React, { useState, useRef } from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import SearchBar from './search-bar';
import InflCard from './influencer-card';
import Pagination from './pagination';
import s from './all-influencers-requested.module.scss';

function AllInfluencers({ influencers }) {
  const initialValue = influencers.filter(
    influencer => !influencer.completionStatus
  );
  const [reqInfluencers, setReqInfluencers] = useState(initialValue);
  const [option, setOption] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [influencersPerPage] = useState(18);
  const searchField = useRef('');
  const selectRef = useRef('');

  const handleSearch = () => {
    setReqInfluencers(
      initialValue.filter(influencer => `${influencer.firstName} ${influencer.lastName}`.includes(searchField.current.value?.toLowerCase()))
    );
  };

  if (option === 0) {
    reqInfluencers.sort((a, b) => {
      if (a.firstName < b.firstName) return -1;
      if (a.firstName > b.firstName) return 1;
      return 0;
    });
  } else if (option === 1) {
    reqInfluencers.sort((a, b) => {
      if (a.username < b.username) return -1;
      if (a.username > b.username) return 1;
      return 0;
    });
  } else if (option === 2) {
    reqInfluencers.sort((a, b) => b.auditRequests - a.auditRequests);
  }

  const countries = Array.from(
    new Set(initialValue.map(influencer => influencer.country?.name))
  ).filter(country => country);
  countries.unshift('All');

  const handleCountry = () => {
    countries.forEach(countryA => {
      if (countryA === selectRef.current.value && selectRef.current.value !== 'All') {
        setReqInfluencers(
          initialValue.filter(
            influencer =>
              influencer.country && influencer.country.name === selectRef.current.value && `${influencer.firstName} ${influencer.lastName}`.includes(searchField.current.value?.toLowerCase())
          )
        );
        setCurrentPage(1);
      } else if (selectRef.current.value === 'All') {
        handleSearch();
        setCurrentPage(1);
      }
    });
  };

  const indexOfLastInfluencer = currentPage * influencersPerPage;
  const indexOfFirstInfluencer = indexOfLastInfluencer - influencersPerPage;
  const currentInfluencers = reqInfluencers.slice(
    indexOfFirstInfluencer,
    indexOfLastInfluencer
  );

  return (
    <>
      <div id="allInfluencers" className={s.root}>
        <Container className={s.root}>
          <div className={s.topBar}>
            <Headline className={s.headline} html="All Influencers Requestes" />
            <SearchBar
              handleSearch={handleCountry}
              searchField={searchField}
            />
          </div>
        </Container>
        <div className={s.controlBar}>
          <Container className={s.container}>
            <div className={s.controlBarWrapper}>
              <div className={s.item}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: `<span>${reqInfluencers.length}</span> </br> Influencers`
                  }}
                />
              </div>
              <div className={s.item}>
                <p
                  className={s.selectTitle}
                  dangerouslySetInnerHTML={{ __html: 'Sort By:' }}
                />
                <select
                  className={s.select}
                  onChange={e => setOption(parseInt(e.target.value))}
                >
                  <option value="0">Name</option>
                  <option value="1">Username</option>
                  <option value="2">Audit Requests</option>
                </select>
              </div>
              <div className={s.item}>
                <p
                  className={s.selectTitle}
                  dangerouslySetInnerHTML={{ __html: 'Country:' }}
                />
                <select
                  className={s.select}
                  ref={selectRef}
                  onChange={handleCountry}
                >
                  {countries.map(country => (
                    <option value={country}>{country}</option>
                  ))}
                </select>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <Container className={s.root}>
        <div className={s.wrapper}>
          <div className={s.flex}>
            {currentInfluencers.map(influencer => (
              <InflCard className={s.card} influencer={influencer} />
            ))}
          </div>
        </div>
        {(Math.ceil(reqInfluencers.length / influencersPerPage) !== 1) && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            influencersPerPage={influencersPerPage}
            totalInfluencers={reqInfluencers.length}
          />
        )}
      </Container>
    </>
  );
}
export default AllInfluencers;
